<div class='container'>
    <div class='mb-3 pt-3'>
        <div class='h3'>Send App notification tool</div>
    </div>

    <!-- Progress panel -->
    <div class="mb-3">
        <div *ngIf="progressLoading" class="alert alert-info d-flex justify-content-between align-items-center">
            <div>Loading notification progress...</div>
            <button class="btn btn-sm btn-outline-secondary" disabled>Refresh</button>
        </div>

        <div *ngIf="!progressLoading && progressError" class="alert alert-danger d-flex justify-content-between align-items-center">
            <div>{{progressError}}</div>
            <button class="btn btn-sm btn-primary" (click)="onRefreshProgress()">Refresh</button>
        </div>

        <div *ngIf="!progressLoading && progressReport" class="progress-report p-5 border rounded bg-light">
            <div class="text-center mb-4"><strong class="h4">Last Notification Process Statistics</strong></div>

            <div class="mb-4">
                <div class="fs-5 mb-2"><strong>Task:</strong></div>
                <div class="mb-3"><span class="fw-semibold fs-5">{{progressReport.code}}</span></div>

                <div class="fs-5 mb-2"><strong>Status:</strong></div>
                <div class="mb-3"><span class="fw-semibold fs-5">{{progressReport.status}}</span></div>
            </div>

            <div class="mb-4">
                <div class="d-flex flex-wrap gap-5 align-items-start">
                    <div class="me-4 mb-3">
                        <div class="text-muted small mb-1">Total Accounts</div>
                        <div class="fs-4"><strong>{{progressReport.totalAccounts}}</strong></div>
                    </div>
                    <div class="me-4 mb-3">
                        <div class="text-muted small mb-1">Total Devices</div>
                        <div class="fs-4"><strong>{{progressReport.totalDevices}}</strong></div>
                    </div>
                    <div class="me-4 mb-3">
                        <div class="text-muted small mb-1">Successful Sends</div>
                        <div class="fs-4"><strong>{{progressReport.successfulSends}}</strong></div>
                    </div>
                    <div class="me-4 mb-3">
                        <div class="text-muted small mb-1">Failed Sends</div>
                        <div class="fs-4"><strong>{{progressReport.failedSends}}</strong></div>
                    </div>
                </div>
            </div>

            <div class="mb-4">
                <div class="progress" style="height:24px; border-radius:6px; overflow:hidden;">
                    <div class="progress-bar" role="progressbar" [style.width.%]="progressReport.progress" [attr.aria-valuenow]="progressReport.progress" [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">{{progressReport.progress}}%</div>
                </div>
            </div>

            <div class="text-center mt-2 mb-4">
                <button class="btn btn-primary refresh-large" (click)="onRefreshProgress()">Refresh</button>
            </div>

            <div *ngIf="progressReport.errorMessage" class="text-danger fs-5 mt-2">{{progressReport.errorMessage}}</div>
        </div>
    </div>

    <!-- New inputs below the report -->
    <div class="card p-3">
        <form>
            <div class="mb-3">
                <div class="h5">Send new notification</div>
            </div>

            <div class="mb-3">
                <label class="form-label">Title</label>
                <input class="form-control" type="text" [(ngModel)]="title" name="notificationTitle" style="height:50px;" />
                <div class="form-text">The title of the notification</div>
            </div>

            <div class="mb-3">
                <label class="form-label">Description</label>
                <input class="form-control" type="text" [(ngModel)]="description" name="notificationDescription" style="height:70px;" />
                <div class="form-text">The description text of the notification</div>
            </div>

            <div class="mb-3">
                <label class="form-label">URL</label>
                <input class="form-control" type="text" [(ngModel)]="url" name="notificationUrl" style="height:50px;" />
                <div class="form-text">The url text of the notification</div>
            </div>

            <div class="mb-3">
                <label class="form-label">Image URL</label>
                <input class="form-control" type="text" [(ngModel)]="imageUrl" name="notificationImageUrl" style="height:50px;" />
                <div class="form-text">The url text of the image of the notification</div>
            </div>

            <div class="mb-3">
                <label class="form-label">Specific Emails</label>
                <div class="form-text mb-1">If any emails are written, then notifications will ONLY be sent to those email addresses regardless of other options ( e.g. Language )</div>
                <textarea class="form-control" rows="4" [(ngModel)]="specificEmailsRaw" name="specificEmails" (input)="onSpecificEmailsRawChange($any($event.target).value)" style="height:90px;"></textarea>
                <div class="form-text">Enter emails separated by commas or new lines. Parsed: <strong>{{specificEmails.length}}</strong></div>
            </div>

            <div class="mb-3">
                <label class="form-label">Language</label>
                <div>
                    <button type="button" class="btn btn-sm me-1" [ngClass]="{'btn-primary': language==='EN', 'btn-outline-primary': language!=='EN'}" (click)="toggleLanguage('EN')">EN</button>
                    <button type="button" class="btn btn-sm me-1" [ngClass]="{'btn-primary': language==='ES', 'btn-outline-primary': language!=='ES'}" (click)="toggleLanguage('ES')">ES</button>
                    <button type="button" class="btn btn-sm" [ngClass]="{'btn-primary': language==='FR', 'btn-outline-primary': language!=='FR'}" (click)="toggleLanguage('FR')">FR</button>
                </div>
                <div class="form-text">The language of the accounts that are about to receive the notification.
                    <br>EN will send to all NON-FRENCH accounts.
                    <br>FR will send to all FR accounts
                    <br>ES will send to all ES accounts
                </div>
                <div class="form-text mt-1">Selected language: <strong>{{language || 'none'}}</strong></div>
            </div>

            <div class="alert alert-warning mt-3">
                <div class="mb-2"><strong>Task code to rerun</strong></div>
                <div class="form-text mb-2">By inserting the Task code in this field , you can continue running the last notification task in case the last notification process failed to a point. The process will continue from where it left off and no duplicate notifications will be send</div>
                <div class="mb-3">
                    <input class="form-control" type="text" [(ngModel)]="taskCode" name="taskCode" />
                </div>

                <div class="mb-2"><strong>Force Run new notification</strong></div>
                <div class="form-text mb-2">If this is checked , then a new notification will be forcefully sent regardless of the last notification status</div>
                <div class="d-flex align-items-center">
                    <input type="checkbox" [(ngModel)]="forceRun" name="forceRun" id="forceRunCheckbox" style="transform:scale(1.4); margin-right:0.5rem;" />
                    <label for="forceRunCheckbox" class="ms-1" style="font-size:1.1rem; font-weight:600;">Force run</label>
                </div>
            </div>

            <div class="text-center mt-3">
                <button class="btn btn-success btn-lg" [disabled]="!canSend()" (click)="onSendClick()">Send notification</button>
            </div>

            <!-- Confirmation modal (simple in-template modal) -->
            <div *ngIf="showConfirm" class="modal-backdrop">
                <div class="modal-dialog-centered">
                    <div class="card modal-card">
                        <div class="modal-card-header">
                            <h3 class="mb-0 text-center">Are you sure you want to send this notification?</h3>
                        </div>

                        <div class="modal-card-body">
                            <div class="alert alert-warning">Once the send notification process starts , there is no way to stop it manually.</div>

                            <div class="mb-2"><strong>Title:</strong> {{title}}</div>
                            <div class="mb-2"><strong>Description:</strong> {{description}}</div>
                            <div class="mb-2"><strong>URL:</strong> {{url}}</div>
                            <div class="mb-2"><strong>Image URL:</strong> {{imageUrl}}</div>
                            <div class="mb-2"><strong>Specific Emails:</strong>
                                <span *ngIf="specificEmails.length > 0">({{specificEmails.length}})</span>
                                <div *ngIf="specificEmails.length > 0; else noneSpecific">
                                    <ul class="email-list">
                                        <li *ngFor="let e of specificEmails">{{e}}</li>
                                    </ul>
                                </div>
                                <ng-template #noneSpecific>None</ng-template>
                            </div>
                            <div class="mb-2"><strong>Language:</strong> {{language || 'none'}}</div>
                            <div class="mb-2"><strong>Task Code:</strong> {{taskCode || 'none'}}</div>
                            <div class="mb-3"><strong>Force Run:</strong> {{forceRun ? 'Yes' : 'No'}}</div>
                        </div>

                        <div class="modal-card-footer d-flex justify-content-end">
                            <button class="btn btn-secondary me-2" (click)="cancelConfirm()">Cancel</button>
                            <button class="btn btn-success" (click)="confirmSend()">Confirm Send</button>
                        </div>
                     </div>
                 </div>
             </div>

            <!-- Result modal (success / error) -->
            <div *ngIf="showResultDialog" class="modal-backdrop">
                <div class="modal-dialog-centered">
                    <div class="card modal-card">
                        <div class="modal-card-header">
                            <h3 class="mb-0 text-center" [ngClass]="{'text-success': resultIsSuccess, 'text-danger': !resultIsSuccess}">{{ resultIsSuccess ? 'Notification completed successfully' : 'Notification failed' }}</h3>
                        </div>

                        <div class="modal-card-body">
                            <div *ngIf="resultIsSuccess" class="alert alert-success">{{ resultMessage }}</div>
                            <div *ngIf="!resultIsSuccess" class="alert alert-danger">{{ resultMessage }}<div class="mt-2"><strong>Status:</strong> {{resultStatus}}</div></div>

                            <div class="mb-3"><strong>Latest status:</strong> {{progressReport?.status || 'n/a'}}</div>
                        </div>

                        <div class="modal-card-footer d-flex justify-content-end">
                            <button class="btn btn-primary" (click)="dismissResult()">Close</button>
                        </div>
                    </div>
                </div>
            </div>

         </form>
     </div>


</div>
